<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-5 col-xs-12">
        @if (title()) {
          <app-title [titles]="[title()]" />
        }
      </div>
      <div class="col-lg-7 col-xs-12">
        @if (!isSuccess()) {
          @if (dataDynamic().html; as html) {
            <div [innerHTML]="html" class="paragraph"></div>
          }
          @if (specification()["email"]; as email) {
            <app-form-item (value)="updateForm($event)" [debounceTime]="1000" [specs]="email"></app-form-item>
          }
          @if (specification()["consent"]; as consent) {
            <app-form-item (value)="updateForm($event)" [specs]="consent" class="consent"></app-form-item>
          }
          @if (dataDynamic().button; as button) {
            <app-button
              (buttonClicked)="submit()"
              [isDisabled]="isSending()"
              [label]="button"
              [size]="'NORMAL'"
              [theme]="'WHITE'" />
          }
        } @else {
          @if (dataDynamic().successHtml; as successHtml) {
            <p [innerHTML]="successHtml" class="paragraph"></p>
          }
        }
      </div>
    </div>
  </div>
</section>
